import React, { useContext, useEffect, useState } from 'react'
import { useRef } from 'react'
import { MdOutlineKeyboardArrowDown } from 'react-icons/md'
import { MdVisibility, MdVisibilityOff } from 'react-icons/md'
import { toast } from 'react-toastify'
import { Auth, UserInfo } from '../../../contexts/allContext'
import classes from './UserPassword.module.css'

const UserPassword = () => {
    const [password, setPassword] = useState('')
    const [confirmUser, setConfirmUser] = useState('')
    const [searchQuery, setSearchQuery] = useState('')
    const [searchResult, setSearchResult] = useState([])
    const [selectedUser, setSelectedUser] = useState(null)

    const { stateAuth } = useContext(Auth)
    const api = process.env.REACT_APP_API_URL
    const token = stateAuth?.token

    const [showPass, setShowPass] = useState(false)
    const [showConfirmPass, setShowConfirmPass] = useState(false)

    const dropdownRef = useRef()

    const toastError = () => {
        toast.dismiss()
        toast.error('Password dont match', {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
        })
    }

    const toastSuccess = () => {
        toast.dismiss()
        toast.success('Password update successfully', {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
        })
    }

    useEffect(() => {
        const fetchData = async () => {
            if (!searchQuery || searchQuery.length < 2 || selectedUser) return
            try {
                const response = await fetch(`${api}/v1/users/?email=${searchQuery}&skip=0&limit=5`, {
                    method: 'GET',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                })
                const data = await response.json()
                setSearchResult(data[1] || [])
            } catch {
                setSearchResult([])
            }
        }

        fetchData()
    }, [searchQuery, selectedUser])

    const handleSelectUser = (user) => {
        setSelectedUser(user)
        setSearchQuery(user?.email)
        setSearchResult([])
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (password !== confirmUser) {
            toastError()
        } else {
            const details = {
                password,
            }
            let postFetch = await fetch(`${api}/v1/admin/user/password/${selectedUser.id}`, {
                method: 'PATCH',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(details),
            })

            if (postFetch.ok) {
                toastSuccess()
                setPassword('')
                setConfirmUser('')
                setSearchQuery('')
                setSelectedUser(null)
            }
        }
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setSearchResult([])
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [])

    return (
        <div className={classes.container}>
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className={classes.wrapper}>
                    <h1>Update User Password</h1>
                    <div className={classes.innerContainer}>
                        <div>
                            <div className={classes.half}>
                                <div className={`${classes.formGroup} ${classes.userSerachclass}`}>
                                    <label>Input Email</label>
                                    <input
                                        type="text"
                                        autoComplete="off"
                                        value={searchQuery}
                                        onChange={(e) => {
                                            setSearchQuery(e.target.value.trim().toLowerCase())
                                            setSelectedUser(null)
                                        }}
                                    />
                                    {searchResult.length > 0 && (
                                        <div className={classes.dropdownWrapper} ref={dropdownRef}>
                                            <div className={classes.dropdownHeader}>
                                                <span>Results</span>
                                                <button
                                                    className={classes.closeButton}
                                                    type="button"
                                                    onClick={() => setSearchResult([])}>
                                                    ✕
                                                </button>
                                            </div>
                                            <ul className={classes.dropdown}>
                                                {searchResult.map((user, index) => (
                                                    <li key={index} onClick={() => handleSelectUser(user)}>
                                                        {user.name} | {user.email} | {user.phone}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                                <div className={classes.formGroup}>
                                    <label>User Info</label>
                                    <div className={classes.fixedField}>
                                        {selectedUser ? `${selectedUser?.name} | ${selectedUser?.phone}` : ''}
                                    </div>
                                </div>
                            </div>

                            <div className={classes.half}>
                                <div className={classes.formGroup}>
                                    <label>Password</label>
                                    <div className={classes.passwordWrapper}>
                                        <input
                                            type={showPass ? 'text' : 'password'}
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            required
                                        />
                                        <span onClick={() => setShowPass(!showPass)} className={classes.eyeIcon}>
                                            {showPass ? <MdVisibilityOff /> : <MdVisibility />}
                                        </span>
                                    </div>
                                </div>

                                <div className={classes.formGroup}>
                                    <label>Confirm Password</label>
                                    <div className={classes.passwordWrapper}>
                                        <input
                                            type={showConfirmPass ? 'text' : 'password'}
                                            value={confirmUser}
                                            onChange={(e) => setConfirmUser(e.target.value)}
                                        />
                                        <span
                                            onClick={() => setShowConfirmPass(!showConfirmPass)}
                                            className={classes.eyeIcon}>
                                            {showConfirmPass ? <MdVisibilityOff /> : <MdVisibility />}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={classes.submit}>
                        <button type="submit">Update</button>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default UserPassword
